import { enableStaticRendering } from 'mobx-react';
import DigitalHumanStore from './digital-human-store';
import { StreamingStore } from '@/stores/streaming-store';

const isServer = typeof window === 'undefined';
enableStaticRendering(isServer);

export type Store = {
  digitalHumanStore: DigitalHumanStore;
  streamingStore: StreamingStore;
};

let store: Store = null;

export default function initializeStore() {
  if (store === null) {
    console.log('🏪 Creating NEW store instance');
    store = {
      digitalHumanStore: new DigitalHumanStore(),
      streamingStore: new StreamingStore(),
    };  
  } else {
    console.log('🏪 Reusing EXISTING store instance');
  }
  return store;
}